/**
 * Country Flag Utilities
 * Provides mapping between country names and their corresponding flag emojis
 * Can be used across the application for consistent country flag display
 */

// Comprehensive mapping of country names to flag emojis
const COUNTRY_FLAGS = {
    // Middle East & North Africa
    'UAE': '🇦🇪',
    'United Arab Emirates': '🇦🇪',
    'Saudi Arabia': '🇸🇦',
    'Kuwait': '🇰🇼',
    'Qatar': '🇶🇦',
    'Bahrain': '🇧🇭',
    'Oman': '🇴🇲',
    'Yemen': '🇾🇪',
    'Jordan': '🇯🇴',
    'Lebanon': '🇱🇧',
    'Syria': '🇸🇾',
    'Iraq': '🇮🇶',
    'Iran': '🇮🇷',
    'Turkey': '🇹🇷',
    'Palestine': '🇵🇸',
    'Israel': '🇮🇱',
    'Egypt': '🇪🇬',
    'Morocco': '🇲🇦',
    'Algeria': '🇩🇿',
    'Tunisia': '🇹🇳',
    'Libya': '🇱🇾',
    'Sudan': '🇸🇩',
    'South Sudan': '🇸🇸',
    'Eritrea': '🇪🇷',
    'Djibouti': '🇩🇯',
    'Somalia': '🇸🇴',
    'Comoros': '🇰🇲',
    'Mauritania': '🇲🇷',
    'Western Sahara': '🇪🇭',

    // South Asia
    'India': '🇮🇳',
    'Pakistan': '🇵🇰',
    'Bangladesh': '🇧🇩',
    'Sri Lanka': '🇱🇰',
    'Nepal': '🇳🇵',
    'Afghanistan': '🇦🇫',
    'Maldives': '🇲🇻',
    'Bhutan': '🇧🇹',

    // Southeast Asia
    'Philippines': '🇵🇭',
    'Indonesia': '🇮🇩',
    'Malaysia': '🇲🇾',
    'Thailand': '🇹🇭',
    'Vietnam': '🇻🇳',
    'Singapore': '🇸🇬',
    'Myanmar': '🇲🇲',
    'Cambodia': '🇰🇭',
    'Laos': '🇱🇦',
    'Brunei': '🇧🇳',
    'East Timor': '🇹🇱',
    'Timor-Leste': '🇹🇱',

    // East Asia
    'China': '🇨🇳',
    'Japan': '🇯🇵',
    'South Korea': '🇰🇷',
    'North Korea': '🇰🇵',
    'Taiwan': '🇹🇼',
    'Mongolia': '🇲🇳',
    'Hong Kong': '🇭🇰',
    'Macau': '🇲🇴',

    // Europe
    'United Kingdom': '🇬🇧',
    'UK': '🇬🇧',
    'Germany': '🇩🇪',
    'France': '🇫🇷',
    'Italy': '🇮🇹',
    'Spain': '🇪🇸',
    'Netherlands': '🇳🇱',
    'Belgium': '🇧🇪',
    'Switzerland': '🇨🇭',
    'Austria': '🇦🇹',
    'Sweden': '🇸🇪',
    'Norway': '🇳🇴',
    'Denmark': '🇩🇰',
    'Finland': '🇫🇮',
    'Poland': '🇵🇱',
    'Czech Republic': '🇨🇿',
    'Hungary': '🇭🇺',
    'Romania': '🇷🇴',
    'Bulgaria': '🇧🇬',
    'Greece': '🇬🇷',
    'Portugal': '🇵🇹',
    'Ireland': '🇮🇪',
    'Iceland': '🇮🇸',
    'Estonia': '🇪🇪',
    'Latvia': '🇱🇻',
    'Lithuania': '🇱🇹',
    'Slovakia': '🇸🇰',
    'Slovenia': '🇸🇮',
    'Croatia': '🇭🇷',
    'Serbia': '🇷🇸',
    'Bosnia and Herzegovina': '🇧🇦',
    'Montenegro': '🇲🇪',
    'North Macedonia': '🇲🇰',
    'Albania': '🇦🇱',
    'Kosovo': '🇽🇰',
    'Ukraine': '🇺🇦',
    'Belarus': '🇧🇾',
    'Moldova': '🇲🇩',
    'Russia': '🇷🇺',
    'Georgia': '🇬🇪',
    'Armenia': '🇦🇲',
    'Azerbaijan': '🇦🇿',

    // North America
    'United States': '🇺🇸',
    'USA': '🇺🇸',
    'Canada': '🇨🇦',
    'Mexico': '🇲🇽',
    'Cuba': '🇨🇺',
    'Jamaica': '🇯🇲',
    'Haiti': '🇭🇹',
    'Dominican Republic': '🇩🇴',
    'Puerto Rico': '🇵🇷',
    'Trinidad and Tobago': '🇹🇹',
    'Barbados': '🇧🇧',
    'Bahamas': '🇧🇸',
    'Grenada': '🇬🇩',
    'Saint Lucia': '🇱🇨',
    'Saint Vincent and the Grenadines': '🇻🇨',
    'Antigua and Barbuda': '🇦🇬',
    'Saint Kitts and Nevis': '🇰🇳',
    'Dominica': '🇩🇲',
    'Belize': '🇧🇿',
    'Guatemala': '🇬🇹',
    'El Salvador': '🇸🇻',
    'Honduras': '🇭🇳',
    'Nicaragua': '🇳🇮',
    'Costa Rica': '🇨🇷',
    'Panama': '🇵🇦',

    // South America
    'Brazil': '🇧🇷',
    'Argentina': '🇦🇷',
    'Chile': '🇨🇱',
    'Colombia': '🇨🇴',
    'Peru': '🇵🇪',
    'Venezuela': '🇻🇪',
    'Ecuador': '🇪🇨',
    'Uruguay': '🇺🇾',
    'Paraguay': '🇵🇾',
    'Bolivia': '🇧🇴',
    'Guyana': '🇬🇾',
    'Suriname': '🇸🇷',
    'French Guiana': '🇬🇫',

    // Africa
    'South Africa': '🇿🇦',
    'Nigeria': '🇳🇬',
    'Kenya': '🇰🇪',
    'Ghana': '🇬🇭',
    'Ethiopia': '🇪🇹',
    'Uganda': '🇺🇬',
    'Tanzania': '🇹🇿',
    'Zimbabwe': '🇿🇼',
    'Zambia': '🇿🇲',
    'Malawi': '🇲🇼',
    'Botswana': '🇧🇼',
    'Namibia': '🇳🇦',
    'Mozambique': '🇲🇿',
    'Angola': '🇦🇴',
    'Congo': '🇨🇬',
    'DR Congo': '🇨🇩',
    'Democratic Republic of Congo': '🇨🇩',
    'Cameroon': '🇨🇲',
    'Chad': '🇹🇩',
    'Niger': '🇳🇪',
    'Mali': '🇲🇱',
    'Burkina Faso': '🇧🇫',
    'Senegal': '🇸🇳',
    'Guinea': '🇬🇳',
    'Sierra Leone': '🇸🇱',
    'Liberia': '🇱🇷',
    'Ivory Coast': '🇨🇮',
    'Cote d\'Ivoire': '🇨🇮',
    'Togo': '🇹🇬',
    'Benin': '🇧🇯',
    'Central African Republic': '🇨🇫',
    'Gabon': '🇬🇦',
    'Equatorial Guinea': '🇬🇶',
    'Sao Tome and Principe': '🇸🇹',
    'Cape Verde': '🇨🇻',
    'Madagascar': '🇲🇬',
    'Mauritius': '🇲🇺',
    'Seychelles': '🇸🇨',
    'Mayotte': '🇾🇹',
    'Reunion': '🇷🇪',
    'Lesotho': '🇱🇸',
    'Eswatini': '🇸🇿',
    'Swaziland': '🇸🇿',

    // Oceania
    'Australia': '🇦🇺',
    'New Zealand': '🇳🇿',
    'Fiji': '🇫🇯',
    'Papua New Guinea': '🇵🇬',
    'Solomon Islands': '🇸🇧',
    'Vanuatu': '🇻🇺',
    'New Caledonia': '🇳🇨',
    'French Polynesia': '🇵🇫',
    'Samoa': '🇼🇸',
    'Tonga': '🇹🇴',
    'Kiribati': '🇰🇮',
    'Tuvalu': '🇹🇻',
    'Nauru': '🇳🇷',
    'Palau': '🇵🇼',
    'Micronesia': '🇫🇲',
    'Marshall Islands': '🇲🇭'
};

/**
 * Get the flag emoji for a given country name
 * @param {string} countryName - The name of the country
 * @returns {string} The flag emoji or a default flag if not found
 */
export function getCountryFlag(countryName) {
    if (!countryName || typeof countryName !== 'string') {
        return '🏳️'; // White flag for invalid input
    }

    // Try exact match first
    if (COUNTRY_FLAGS[countryName]) {
        return COUNTRY_FLAGS[countryName];
    }

    // Try case-insensitive match
    const normalizedName = countryName.toLowerCase();
    for (const [key, value] of Object.entries(COUNTRY_FLAGS)) {
        if (key.toLowerCase() === normalizedName) {
            return value;
        }
    }

    // Return default flag if no match found
    return '🏳️';
}

/**
 * Get all available country names
 * @returns {string[]} Array of all country names
 */
export function getAvailableCountries() {
    return Object.keys(COUNTRY_FLAGS);
}

/**
 * Check if a country flag is available
 * @param {string} countryName - The name of the country
 * @returns {boolean} True if flag is available, false otherwise
 */
export function hasCountryFlag(countryName) {
    if (!countryName || typeof countryName !== 'string') {
        return false;
    }

    // Check exact match
    if (COUNTRY_FLAGS[countryName]) {
        return true;
    }

    // Check case-insensitive match
    const normalizedName = countryName.toLowerCase();
    return Object.keys(COUNTRY_FLAGS).some(key =>
        key.toLowerCase() === normalizedName
    );
}

/**
 * Get country flag with fallback options
 * @param {string} countryName - The name of the country
 * @param {string} fallbackFlag - Custom fallback flag (default: '🏳️')
 * @returns {string} The flag emoji or fallback flag
 */
export function getCountryFlagWithFallback(countryName, fallbackFlag = '🏳️') {
    const flag = getCountryFlag(countryName);
    return flag === '🏳️' ? fallbackFlag : flag;
}

// Export the flags object for direct access if needed
export { COUNTRY_FLAGS };
